(function (window, document, $) {

    jQuery(document).ready(function($) {

        if ($('.wpg-wdp-product-anchor-nav').length) {

            $( '.wpg-wdp-product-anchor-nav' ).css({top: ($( '.wpg-wdp-product-anchor-nav' ).outerHeight() * -1)});
            $( '.wpg-wdp-single-product-details-content' ).css({top: ($( '.wpg-wdp-single-product-details-content' ).outerHeight() * -1)});

            if (!$('.wpg-wdp-single-product-details-content-sticky-wrapper').length) {
                //$( '.wpg-wdp-single-product-details-content' ).wrap('<div class="wpg-wdp-single-product-details-content-sticky-wrapper" style="height:' + $( '.wpg-wdp-single-product-details-content' ).outerHeight() + 'px;"></div>');
                $( '.wpg-wdp-single-product-details-content' ).wrap('<div class="wpg-wdp-single-product-details-content-sticky-wrapper"></div>');
            }

            $(window).on('resize', function() {
                $( '.wpg-wdp-single-product-details-content' ).css({width: $('.wpg-wdp-single-product-details').width()});

                if( $( '.wpg-wdp-single-product-details-content' ).outerHeight() > 0) {
                    $( '.wpg-wdp-single-product-details-content-sticky-wrapper' ).css({height: $( '.wpg-wdp-single-product-details-content' ).outerHeight()});
                }
            });

            var sticky = new Waypoint.Sticky({
                element: $( '.wpg-wdp-product-anchor-nav' ),
                wrapper: '<div class="wpg-wdp-product-anchor-nav-sticky-wrapper" />',
                handler: function(direction) {
                    // added a selector for the A/B test with the sticky bar (MM-3765)
                    var selector = ".wpg-wdp-single-product-details-content";
                    var top = 13;

                    // the sticky bar test is only on desktop
                    if ($('body.wdp-sticky-bar-test').length && $(window).width() >= 1200) {
                        selector = ".wpg-wdp-sticky-bar";
                        top = $('.wpg-wdp-top-bar').length ? $('.wpg-wdp-top-bar').outerHeight() : 0;
                    }
                
                    $(selector).toggleClass('stuck');

                    if ($('.wpg-wdp-top-bar').length) {
                        $('.wpg-wdp-top-bar').toggleClass('stuck');
                    }

                    if (direction === "down") {
                        $( '.wpg-wdp-product-anchor-nav' ).css({top: 0});
                        $(selector).css({top: top});
                    } else {
                        $( '.wpg-wdp-product-anchor-nav' ).css({top: ($( '.wpg-wdp-product-anchor-nav' ).outerHeight() * -1)});
                        $(selector).css({top: ($(selector).outerHeight() * -1)});
                    }
                }, 
            });

            var anchorWaypoint = new Waypoint({
                element: $( '.wpg-wdp-product-anchor-nav-sticky-wrapper' ),
                handler: function(direction) {
                    if (direction === "down") {
                        if ($('body.theme-happinez').length) {
                            if ($('.promo-banner-wrapper').length) {
                                $('.promo-banner-wrapper').css({top: ($( '.promo-banner-wrapper' ).outerHeight() * -1)})
                            }
                            $('header.header').css({top: ($( 'header.header' ).outerHeight() * -1)})
                        }
                    } else {
                        if ($('body.theme-happinez').length) {
                            var offset = 0;
                            if ($('.promo-banner-wrapper').length) {
                                offset = $('.promo-banner-wrapper').outerHeight();
                                $('.promo-banner-wrapper').css({top: 0})
                            }
                            $('header.header').css({top: offset})
                        }
                    }
                }, 
                offset: function() {
                    return $( '.wpg-wdp-product-anchor-nav-sticky-wrapper' ).outerHeight() * -0.1;
                }
            });

            var $bottomAnchorWPEl = false;
            if ($('.wpg-wdp-product-block_other_products').length) {
                $bottomAnchorWPEl = $('.wpg-wdp-product-block_other_products');
            } else if($('footer').length) {
                $bottomAnchorWPEl = $('footer').length;
            }

            if ($bottomAnchorWPEl.length) {
                var bottomAnchorWaypoint = new Waypoint({
                    element: $bottomAnchorWPEl,
                    handler: function(direction) {

                        if (direction === "down") {
                            $( '.wpg-wdp-product-anchor-nav' ).css({top: ($( '.wpg-wdp-product-anchor-nav' ).outerHeight() * -1)});
                            $( '.wpg-wdp-single-product-details-content' ).css({top: (($( '.wpg-wdp-single-product-details-content' ).outerHeight() + 10) * -1)});
                        } else {
                            $( '.wpg-wdp-product-anchor-nav' ).css({top: 0});
                            $( '.wpg-wdp-single-product-details-content' ).css({top: 13});
                        }
                    }, 
                    offset: function() {
                        return $( '.wpg-wdp-single-product-details-content' ).outerHeight();
                    }
                });
            }
        }
    });
}(window, document, jQuery));